export default "__VITE_ASSET__DdorbyWM__"